import { Metadata } from 'next'

const metadata: Metadata = {
  title: 'How to Pack Golf Clubs for Shipping | ShipSticks',
  description:
    'How to pack and label golf clubs for shipping with ShipSticks ' +
    'for less than regular carriers charge.',
  alternates: {
    canonical: 'https://www.shipsticks.com/pack',
  },
}

export default metadata
